<div class="list-topbar">
  <p>Create roles to define permissions, then assign them to users</p>
  @if (canCreate()) {
    <button tuiButton appearance="primary" size="s" iconStart="@tui.plus" type="button" (click)="add.emit()">
      Add role
    </button>
  }
</div>

@if (isLoading()) {
  <tui-loader size="l" />
} @else if (!canList()) {
  <div tuiNotification appearance="warning">
    You do not have permission to see the roles of your organization.
  </div>
} @else {
  <div class="role-rows">
    @for (role of roles(); track role.id) {
      <div class="role-row">
        <span class="role-name">{{ role.name }}</span>
        <span class="actions">
          @if (canEdit()) {
            <button
              tuiButton
              appearance="flat"
              size="s"
              iconStart="@tui.pencil"
              type="button"
              (click)="edit.emit(role.id)"
            >
              Edit
            </button>
          }
          @if (canCopy()) {
            <button
              tuiButton
              appearance="flat-grayscale"
              size="s"
              iconStart="@tui.copy"
              type="button"
              (click)="copy.emit(role.id)"
            >
              Duplicate
            </button>
          }
          @if (canDelete() && role.id !== ownRoleId()) {
            <button
              tuiButton
              appearance="primary-destructive"
              size="s"
              iconStart="@tui.trash-2"
              type="button"
              (click)="onDelete(role)"
            >
              Delete
            </button>
          }
        </span>
      </div>
    } @empty {
      <p class="empty">No roles found.</p>
    }
  </div>
}
